module.exports = __webpack_public_path__ + "static/media/search-default.d6228d44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/search-default.svg
// module id = 997
// module chunks = 0